import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ConfigService } from 'common';

@Component({
  selector: 'gsp-imei-generator',
  template: `<mat-icon (click)="sendIMEI();" 
  style="cursor: pointer;
    padding-left: 8px;
    width: 100%;
    height: 40px;
    vertical-align: middle;
    font-size: 40px;"
  title = "Generate IMEI"
  *ngIf="isLowerEnvironment">input</mat-icon>`
})
export class ImeiGeneratorComponent implements OnInit {
  @Output() generateIMEIEvent = new EventEmitter<string>();
  isLowerEnvironment: boolean = true;
  constructor(
    private configService: ConfigService,
  ) { }

  ngOnInit() {
    this.isLowerEnvironment = JSON.parse(this.configService.resourceEditMode.toLowerCase());
  }

  generateIMEI(): string {
    let pos: number;
    let str: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let sum: number = 0;
    let final_digit: number = 0;
    let ImeiNumber: number = 0;
    let len_offset: number = 0;
    let len: number = 15;

    const rbi: string[] = ["01", "10", "30", "33", "35", "44", "45", "49", "50", "51", "52", "53", "54", "86", "91", "98", "99"];
    const arr: string[] = rbi[Math.floor(Math.random() * rbi.length)].split("");
    str[0] = Number(arr[0]);
    str[1] = Number(arr[1]);
    pos = 2;

    while (pos < len - 1) {
      str[pos++] = Math.floor(Math.random() * 10) % 10;
    }

    len_offset = (len + 1) % 2;
    for (pos = 0; pos < len - 1; pos++) {
      if ((pos + len_offset) % 2) {
        ImeiNumber = str[pos] * 2;
        if (ImeiNumber > 9) {
          ImeiNumber -= 9;
        }
        sum += ImeiNumber;
      }
      else {
        sum += str[pos];
      }
    }

    final_digit = (10 - (sum % 10)) % 10;
    str[len - 1] = final_digit;
    let IMEI: string = str.join('');
    IMEI = IMEI.substring(0, len);
    return IMEI;
  }

  sendIMEI(): void {
    this.generateIMEIEvent.emit(this.generateIMEI());
  }
}
